import React, { useState, createContext, useContext } from "react";
import Content from "../components/Content";
import Main from "../components/Main";
import Sidebar from "../components/Sidebar";
import Wrapper from "../components/Wrapper";

const SidebarContext = createContext();
const MOBILE_BREAKPOINT = 991.98;

export const useSidebar = () => useContext(SidebarContext);

const Dashboard = ({ children }) => {
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  const [sidebarOpen, setSidebarOpen] = useState(
    typeof window !== "undefined" ? window.innerWidth > MOBILE_BREAKPOINT : true
  );

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => setSidebarOpen(false);

  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileView(mobile);
      setSidebarOpen((prev) => {
        if (mobile) return false;
        if (!mobile && prev === false) return true;
        return prev;
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update Main margin based on sidebar state and screen size.
  React.useEffect(() => {
    const mainElement = document.querySelector(".main");
    if (mainElement) {
      mainElement.style.marginLeft = isMobileView ? "0" : sidebarOpen ? "250px" : "0";
    }
  }, [sidebarOpen, isMobileView]);

  return (
    <SidebarContext.Provider value={{ sidebarOpen, toggleSidebar, closeSidebar }}>
      <Wrapper>
        <Sidebar isOpen={sidebarOpen} isMobile={isMobileView} />
        {isMobileView && sidebarOpen && (
          <button
            type="button"
            className="mobile-sidebar-overlay"
            onClick={closeSidebar}
            aria-label="Close sidebar"
          />
        )}
        <Main>
          <Content>{children}</Content>
        </Main>
      </Wrapper>
    </SidebarContext.Provider>
  );
};

export default Dashboard;

